import { useEffect, useState } from 'react';
import {
  RequestGetTermsVerificationAsync,
  RequestPutSelfbillAgreementConfirmation,
} from '../../../requests/transaction';

export const useSelfBillTerms = (
  userId: string,
  userType: 'influencer' | 'agency'
) => {
  const [isSelfBillModalOpen, setIsSelfBillModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>();
  const toggleModal = () => setIsSelfBillModalOpen(!isSelfBillModalOpen);

  useEffect(() => {
    RequestGetTermsVerificationAsync(userId, userType)
      .then(setIsSelfBillModalOpen)
      .catch(() => setIsSelfBillModalOpen(true));
  }, [userId, userType]);

  const acceptTerms = () => {
    setIsLoading(true);
    setError(undefined);
    RequestPutSelfbillAgreementConfirmation()
      .then(() => toggleModal())
      .catch(() => setError('Something went wrong, please try again later.'))
      .finally(() => setIsLoading(false));
  };

  return {
    isSelfBillModalOpen,
    acceptTerms,
    error,
    isLoading,
  };
};
